export default __webpack_public_path__ + "static/media/contact.2f0cbd64.svg";